import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ExecutionDataDownloadQuery, PollExtractResponse } from '../models/extraction-reports.model';

@Injectable({
  providedIn: 'root',
})
export class ExtractionReportsService {
  private readonly apiUrl = `${environment.apiBaseUrl}/api/v1/data`;

  constructor(private http: HttpClient) {}

  pollExtract(requestId: string): Observable<PollExtractResponse> {
    const params = new HttpParams().set('request_id', requestId);

    return this.http.get<PollExtractResponse>(`${this.apiUrl}/poll_extract`, {
      params,
      headers: {
        accept: 'application/json',
      },
    });
  }

  downloadExecutionData(query: ExecutionDataDownloadQuery): Observable<HttpResponse<Blob>> {
    const params = new HttpParams()
      .set('request_id', query.request_id)
      .set('document_model', query.document_model)
      .set('data_type', query.data_type)
      .set('days', String(query.days));

    return this.http.get(`${this.apiUrl}/execution_data`, {
      params,
      observe: 'response',
      responseType: 'blob',
    });
  }
}
